import React from "react";
import RecordPage from "../../components/RecordPage";

export default function Positions() {
  return (
    <RecordPage title="سمت‌ها" subtitle="افزودن، ویرایش و حذف سمت‌های سازمانی" endpoint="/positions" createLabel="افزودن سمت"
      canCreate canEdit canDelete
      columns={[{ key: "name", label: "عنوان سمت" }]}
      fields={[{ name: "name", label: "عنوان سمت", required: true, full: true }]} />
  );
}
